import React, { useState, useEffect } from 'react';
import axios from '../../api/axiosClient';
import Slider from 'react-slick';
import { Box, Typography, Button } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductMain from './ProductMain';
import HintFlowers from './HintFlowers'
import { useNavigate } from 'react-router-dom';
import { getFromCache, saveToCache } from '../utils/cache';
import { getSliderSettings } from '../utils/sliderSettings';
import ErrorNotice from '../common/ErrorNotice';

const CACHE_KEY = 'main-categories';

const MainPageCategories = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const cached = getFromCache(CACHE_KEY);
    if (cached) {
      setCategories(cached);
      return;
    }

    axios.get('/api/main-categories/')
      .then(response => {
        const categoryRequests = response.data.map(category =>
          axios.get(`/api/compositions/?categories=${category.slug}`)
            .then(prodResponse => ({ ...category, products: prodResponse.data.results }))
            .catch(() => ({ ...category, products: [] }))
        );
        Promise.all(categoryRequests).then(categoriesWithProducts => {
          setCategories(categoriesWithProducts);
          saveToCache(CACHE_KEY, null, categoriesWithProducts);
          setError('');
        });
      })
      .catch(() => {
        setError('Не удалось загрузить категории товаров.');
      });
  }, []);

  const handleSeeAllClick = (parentSlug, categorySlug) => {
    navigate(`/${parentSlug}/${categorySlug}`);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <ErrorNotice>{error}</ErrorNotice>
      {categories.map(category => {
        const products = category.products || [];
        return (
          <Box key={category.slug} sx={{ mt: 6, overflow: 'hidden', width: '100%'}}> {/* Добавляем нижний отступ между категориями */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 6, }}>
              <Typography variant="h2">{category.name}</Typography>
              <Button
                style={{ color: '#f2003c' }}
                onClick={() => handleSeeAllClick(category.parent, category.slug)}
              >
                Смотреть всё
              </Button>
            </Box>

            {products.length > 0 && (
              <Slider {...getSliderSettings(products.length, { autoplaySpeed: 4000 })}>
                {products.map(product => (
                  <Box key={product.id} sx={{ flexGrow: 1 }}>
                    <ProductMain product={product} />
                  </Box>
                ))}
              </Slider>
            )}
          </Box>
        );
      })}
      <Box>
        <HintFlowers />
      </Box>
    </Box>
  );
};

export default MainPageCategories;
